module.exports = __webpack_public_path__ + "static/media/reject_email_invite.79ab7dd9.svg";